import { DataSecurityEvent } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetDataSecurityAccessLogRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetDataSecurityAccessLogResponse = PaginatedResource<DataSecurityEvent>;

export const getDataSecurityAccessLog =
	createGetEndpoint<GetDataSecurityAccessLogRequest, GetDataSecurityAccessLogResponse>(
		(request) => `/api/v3/data-security/organization/access-log?${getQueryString(request)}`
	);
